import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { navigate } from "gatsby";
import {
	AES_Encryption,
	GetDataFromServer,
	SetParameter,
	ValidatePhone,
} from "../../../../../hooks";
import { APP_ID, REGEX, SERVER_URL } from "../../../../../constants/index";

import Success_Img from "../../../../../assets/images/pay_success.png";
import Error_Img from "../../../../../assets/images/error.png";
import AlertModal from "../../../../atoms/AlertModal";
import Loader from "../../../../atoms/Loader";
import { useAlert } from "react-alert";
import { ValidateAll } from "../modal-validation.helper";

const FlotillaForm = ({ Heading = "Cotizador de Flotilla", img, isImage }) => {
	const alert = useAlert();
	const [errors, setErrors] = useState({});
	const [disabled, setDisabled] = useState(false);
	const [modalAlert, setAlert] = useState({
		show: false,
		reason: null,
		img: null,
		heading: "",
		content: "",
		btn: "",
		subContent: "",
	});
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		id_product: 1,
		physical_person: 1,
		business_name: "",
		contact_name: "",
		phone: "",
		email: "",
		zip: "",
		estado: [],
		municipio: [],
		colonia: [],
		state: "",
		street: "",
		delegation: "",
		colony: "",
	});

	const onClickHandler = async () => {

	
		let ERR = {};
		let {
			physical_person,
			business_name,
			colony,
			contact_name,
			phone,
			email,
			zip,
		} = data;

		if (
			contact_name.length > 0 ,
			phone.length > 0 ,
			email.length > 0 ,
			zip.length > 0 ,
			colony.length > 0
		) {



			if (
				REGEX["phone"].test(phone) &&
				phone.length <= 10 &&
				ValidatePhone(phone, 10) &&
				REGEX["number"].test(zip) &&
				REGEX["email"].test(email)
			) {

				console.log(contact_name)

				setData({ ...data });
				setErrors({});
				const url = SERVER_URL + "bts_ws_quote_pymes_web.aspx";
				data.colony = [data.colonia]
				data.nombre = contact_name
				const param = SetParameter(data, APP_ID);

				console.log(data)

				setLoading(true);
				GetDataFromServer(url, AES_Encryption(param), (err, resp) => {

					console.log(err)
					
					if (err) {
						setLoading(false);

						setAlert({
							show: true,
							heading: "iUps, parece que hubo un error!",
							content:
								err?.data?.message ||
								"Por favor verifica que los dalos sean los correctos.",
							img: Error_Img,
							btn: "Aceptar",
						});
					}
					if (resp) {
						setLoading(false);
						setAlert({
							show: true,
							heading: "¡Gracias por tu confianza!",
							content: "Recibimos tu solicitud.",
							subContent:
								"En breve uno de los asesores y gurús de tranquilidad te contactará para hacerte llegar tu información.",
							img: Success_Img,
							btn: "Aceptar",
						});
					}
				});
			} else {
				if (!REGEX["phone"].test(phone) || !ValidatePhone(phone, 10)) {
					ERR = { ...ERR, phone: true };
					setErrors({ ...errors, ...ERR });
					return alert.show(
						"el número de teléfono no está en el formato correcto",
					);
				}

				if (!REGEX["number"].test(zip)) {
					ERR = { ...ERR, zip: true };
					setErrors({ ...errors, ...ERR });
					return alert.show("el código postal debe ser un número");
				}

				if (!REGEX["email"].test(email)) {
					ERR = { ...ERR, email: true };
					setErrors({ ...errors, ...ERR });
					return alert.show(
						"el correo electrónico no tiene el formato correcto",
					);
				}
			}
			return;
		}
		if (contact_name.length == 0) {
			ERR = { ...ERR, contact_name: true };
		} else {
			let newErr = errors;
			delete newErr["contact_name"];
			setErrors(newErr);
		}
		if (colony.length == 0) {
			ERR = { ...ERR, colony: true };
		} else {
			let newErr = errors;
			delete newErr["colony"];
			setErrors(newErr);
		}
		// if (phone.length == 0) {
		// 	ERR = { ...ERR, phone: true };
		// } else {
		// 	let newErr = errors;
		// 	delete newErr["phone"];
		// 	setErrors(newErr);
		// }
		if (email.length == 0) {
			ERR = { ...ERR, email: true };
		} else {
			let newErr = errors;
			delete newErr["email"];
			setErrors(newErr);
		}
		if (zip.length == 0) {
			ERR = { ...ERR, zip: true };
		} else {
			let newErr = errors;
			delete newErr["zip"];
			setErrors(newErr);
		}

		setErrors({ ...errors, ...ERR });
		alert.show("Por favor complete todos los campos resaltados.");
	};

	const formChangeHandler = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		let elem_type = e.target.type;

		if (name == "phone") {
			elem_type = "phone";
		} else if (name == "email") {
			elem_type = "email";
		} else if (name == "zip") {
			elem_type = "number";
		}

		if (!ValidateAll(elem_type, value)) {
			setErrors({ ...errors, [name]: true });
		} else {
			let newErr = errors;
			delete newErr[name];
			setErrors(newErr);
		}

		if (name == "zip") {
			if (value.length < 6) {
				if (value.length == 5) {
					const encryptedString = AES_Encryption(
						SetParameter({ cp: value }, APP_ID),
					);
					const url = `${SERVER_URL}bts_ws_get_zip_code_data.aspx`;

					return GetDataFromServer(url, encryptedString, (err, res) => {
						const { response, error_message, error } = err;
						if (error) alert.show(error_message);
						if (response.length == 0) {
							return setData({
								...data,
								estado: [],
								municipio: [],
								[name]: value,
							});
						}
						return setData({
							...data,
							estado: [...new Set(response.map((a) => a.estado))],
							municipio: [...new Set(response.map((a) => a.municipio))],
							state: [...new Set(response.map((a) => a.estado))][0],
							delegation: [...new Set(response.map((a) => a.municipio))][0],
							colony: [],
							colonia: [...new Set(response.map((a) => a.asentamiento))],
							[name]: value,
						});
					});
				} else {
					return setData({ ...data, [name]: value });
				}
			}
		} else {
			return setData({ ...data, [name]: value });
		}
	};

	return (
		<Wrapper
			className='p-4'
			style={{
				minHeight: 550,
				background: "#5a68a1",
			}}>
			<div
				className='text-center'
				style={{
					position: "relative",
				}}>
				<Title>{Heading}</Title> &nbsp;{" "}
				{isImage && (
					<img
						style={{
							filter: "invert(1)",
							position: "absolute",
							right: 0,
							top: 0,
							width: "100%",
							maxWidth: 30,
							height: "auto",
						}}
						src={img}
						alt='logo'
					/>
				)}
			</div>
			<Step1
				errors={errors}
				data={data}
				setData={setData}
				disabled={disabled}
				formChangeHandler={formChangeHandler}
				onClickHandler={onClickHandler}
			/>

			{/* Modal Alert to show success or error messages */}
			{modalAlert.show && (
				<AlertModal
					heading={modalAlert.heading}
					content={modalAlert.content}
					subContent={modalAlert.subContent}
					img={modalAlert.img}
					btn={modalAlert.btn}
					modalShow={modalAlert.show}
					setModalShow={() => setAlert({ ...modalAlert, show: false })}
				/>
			)}
			{/* Loade */}
			{loading && <Loader />}
		</Wrapper>
	);
};

const Step1 = ({
	errors,
	data,
	formChangeHandler,
	setData,
	onClickHandler,
}) => {
	return (
		<>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Nombre</label>
					<input
						className='form-control'
						type='text'
						name='contact_name'
						style={errors?.contact_name ? { borderColor: "red" } : {}}
						value={data?.contact_name}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Correo</label>
					<input
						className='form-control'
						type='text'
						name='email'
						style={errors?.email ? { borderColor: "red" } : {}}
						value={data?.email}
						onChange={formChangeHandler}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Teléfono</label>
					<input
						className='form-control'
						maxLength={10}
						name='phone'
						style={errors?.phone ? { borderColor: "red" } : {}}
						value={data?.phone}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-6'>
					<label style={{ color: "white" }}>Persona</label>
					<div sytle={{ width: "100%" }}>
						<div className='custom-radio d-inline-block'>
							<input
								type='radio'
								id='fis'
								name='physical_person'
								value='1'
								checked={data?.physical_person == 1}
								onChange={formChangeHandler}
							/>
							<label htmlFor='fis' style={{ color: "white" }}>
								Física
							</label>
						</div>
						<div className='custom-radio d-inline-block ml-masc'>
							<input
								type='radio'
								id='mor'
								name='physical_person'
								value='0'
								checked={data?.physical_person == 0}
								onChange={formChangeHandler}
							/>
							<label htmlFor='mor' style={{ color: "white" }}>
								Moral
							</label>
						</div>
					</div>
				</div>
			</div>

			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Código Postal</label>
					<input
						className='form-control'
						type='text'
						name='zip'
						maxLength={5}
						value={data?.zip}
						style={errors?.zip ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Estado</label>
					<div className='custom-select-container'>
						<select
							className='form-control'
							name='state'
							style={errors?.state ? { borderColor: "red" } : {}}
							value={data?.state}
							onChange={formChangeHandler}>
							<option value={0} disabled selected>
								Seleccione
							</option>
							{data?.estado?.map((item) => (
								<option selected={item === data?.state} key={item} value={item}>
									{item}
								</option>
							))}
						</select>
						<span className='custom-arrow' />
					</div>
				</div>
			</div>

			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Municipio / Delegación</label>
					<div className='custom-select-container'>
						<select
							className='form-control'
							name='delegation'
							style={errors?.state ? { borderColor: "red" } : {}}
							value={data?.delegation}
							onChange={formChangeHandler}>
							<option value={0} disabled selected>
								Seleccione
							</option>
							{data?.municipio?.map((item) => (
								<option
									selected={item === data?.delegation}
									key={item}
									value={item}>
									{item}
								</option>
							))}
						</select>
						<span className='custom-arrow' />
					</div>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Colonia</label>
					<select
							className='form-control'
							name='colony'
							style={errors?.state ? { borderColor: "red" } : {}}
							value={data?.colony}
							onChange={formChangeHandler}>
							<option value={0} selected>
								Seleccione
							</option>
							{data?.colonia?.map((item) => (
								<option
									key={item}
									value={item}>
									{item}
								</option>
							))}
						</select>
					{/* <input
						className='form-control'
						type='text'
						name='colony'
						value={data?.colony}
						style={errors?.colony ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/> */}
				</div>
			</div>

			<div className='row'>
				<div className='col-sm-12'>
					<label style={{ color: "white" }}>Calle</label>
					<input
						className='form-control'
						type='text'
						name='street'
						value={data?.street}
						style={errors?.street ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/>
				</div>
			</div>

			{data?.physical_person == 0 && (
				<div className='row'>
					<div className='col-sm-12'>
						<label style={{ color: "white" }}>Razón Social</label>
						<input
							className='form-control'
							type='text'
							name='business_name'
							style={errors?.business_name ? { borderColor: "red" } : {}}
							value={data?.business_name}
							onChange={formChangeHandler}
						/>
					</div>
				</div>
			)}

			<div className='row'>
				<div className='col-sm-12 text-center'>
					<Button onClick={() => onClickHandler(1)}>Siguiente</Button>
				</div>
			</div>
		</>
	);
};

export default FlotillaForm;

const Title = styled.p`
	font-size: 40px;
	color: white;

	@media (max-width: 768px) {
		font-size: 24px;
		margin-bottom: 0px;
	}
`;

const Tabs = styled.p`
	font-size: 29px;
	color: white;
	width: 20px;
	cursor: pointer;
	&:first-child {
		margin-right: 12px;
	}
`;

export const Button = styled.button`
	background: #f89900;
	border: 3px solid white;
	color: white;
	text-align: center;

	padding: 11px;
	border-radius: 100px;
	width: 200px;
	margin-top: 10%;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 7%;
`;

export const Wrapper = styled.section`
	align-items: center;
	min-height: 550px;
	background: #5a68a1;
	border-radius: 20px;
	height: auto;
	margin-left: auto;
	margin-right: auto;
	height: auto;
	@media (max-width: 768px) {
		margin-top: 17%;
	}

	.form-group {
		display: block;
		margin-bottom: 15px;

		@media (max-width: 768px) {
			margin-bottom: 5px;
		}
	}

	.form-group input {
		padding: 0;
		height: initial;
		width: initial;
		margin-bottom: 0;
		display: none;
		cursor: pointer;
	}

	.form-group label {
		position: relative;
		cursor: pointer;
		color: white;
	}

	.form-group label:before {
		content: "";
		-webkit-appearance: none;
		background-color: transparent;
		border: 2px solid white;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
			inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
		padding: 10px;
		display: inline-block;
		position: relative;
		vertical-align: middle;
		cursor: pointer;
		margin-right: 5px;
	}

	.form-group input:checked + label:after {
		content: "";
		display: block;
		position: absolute;
		top: 2px;
		left: 9px;
		width: 6px;
		height: 14px;
		border: solid #0079bf;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}

	[type="radio"]:checked,
	[type="radio"]:not(:checked) {
		position: absolute;
		left: -9999px;
	}
	[type="radio"]:checked + label,
	[type="radio"]:not(:checked) + label {
		position: relative;
		padding-left: 28px;
		cursor: pointer;
		line-height: 20px;
		display: inline-block;
		color: #666;
	}
	[type="radio"]:checked + label:before,
	[type="radio"]:not(:checked) + label:before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		width: 18px;
		height: 18px;
		border: 1px solid #ddd;
		border-radius: 100%;
		background: #fff;
	}
	[type="radio"]:checked + label:after,
	[type="radio"]:not(:checked) + label:after {
		content: "";
		width: 18px;
		height: 18px;
		border: 2px solid white;
		background: #3cdbc0;
		position: absolute;

		border-radius: 100%;
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
	[type="radio"]:not(:checked) + label:after {
		opacity: 0;
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	[type="radio"]:checked + label:after {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
		left: 0;
	}

	.disabled {
		select {
			opacity: 0.8 !important;
		}
	}
`;
